import React from 'react';
import { NavLink } from 'react-router-dom';

const SideBarItem = ({ to, children, className }) => {
    return (
        <NavLink className={`sidebar-item ${className}`} to={to}>{children}</NavLink>
    );
}

export default SideBarItem;